import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Product } from '../../core/models/interfaces-general';
import { ProductImageCarouselComponent } from './product-image-carousel.component';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [CommonModule, RouterLink, ProductImageCarouselComponent],
  template: `
    <a
      [routerLink]="product.url || null"
      class="cursor-pointer flex flex-col h-full rounded-3xl p-2 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl bg-white select-none"
    >
      <div class="relative w-full aspect-square rounded-2xl overflow-hidden bg-gray-100">
        <div
          *ngIf="product.discountPercentage"
          class="absolute top-3 left-3 z-20 px-3 py-1 rounded-full text-white text-xs font-bold tracking-wider shadow-sm pointer-events-none"
          style="background-color: var(--bg-main);"
        >
          -{{ product.discountPercentage }}% OFF
        </div>

        <app-product-image-carousel [images]="product.images" [alt]="product.name"></app-product-image-carousel>
      </div>

      <div class="mt-4 px-1 flex flex-col flex-grow justify-between">
        <h3 class="text-sm sm:text-base font-semibold text-gray-800 line-clamp-2 leading-tight">
          {{ product.name }}
        </h3>

        <div class="mt-2 flex items-center gap-2 flex-wrap">
          <span
            *ngIf="product.originalPrice"
            class="text-xs sm:text-sm line-through font-normal"
            style="color: var(--text-accent);"
          >
            {{ product.currency || 'S/' }}{{ product.originalPrice | number:'1.2-2' }}
          </span>

          <span
            class="text-sm sm:text-base font-bold"
            style="color: var(--bg-main);"
          >
            {{ product.currency || 'S/' }}{{ product.discountPrice | number:'1.2-2' }}
          </span>
        </div>
      </div>
    </a>
  `
})
export class ProductCardComponent {
  @Input({ required: true }) product!: Product;
}
